import React from "react";
import {Route, Routes} from 'react-router-dom';
import { AnimatePresence, motion } from "framer-motion";
import Home from './Pages/Home'
import Search from './Pages/Search'
import SearchTv from "./Pages/SearchTv";
import Navbar from './components/Navbar/Navbar';
import MovieDetails from "./Pages/MovieDetails";
import Movies from "./Pages/Movies";
import Tvshow from "./Pages/Tvshow";
import TvshowDetails from "./Pages/TvshowDetails";
import './index.css';
import { useGlobalContext } from "./Utils/ContextApi";
import Footer from "./components/Footer/Footer";

function App() {
  const{searchMovies} = useGlobalContext
  console.log(searchMovies)
  return (
    <div>
      <Navbar />
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/movies' element={<Movies />} />
          <Route path='/tvshows' element={<Tvshow />} />
          <Route path='/tvshows/:id' element={<TvshowDetails />} />
          <Route path="/search" element={<Search />} />
          <Route path="/searchtv" element={<SearchTv />} />
          <Route path="/movie/:id" element={<MovieDetails />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
